export default {
	countryCode: null,
	/** Navigation related state */
	navigation: {
		/** Burger Button state. 'true' will show the navigation on small
		 * devices
		 */
		burgerActive: false,

		/** Current $route.name */
		current: "",
	},
	status: {
		/**
		 * Is the App performing some asynchronous call at this moment?
		 */
		loading: false,

		/**
		 * Did the asynchronous call result in some kind of server/application
		 * error?
		 */
		error: false,

		/**
		 * Is the user just landing on the current page? We can load only what is absolutely necessary for an improved landing experience.
		 */
		justLanding: true,
	},
	/** Unscrambler-like query related state */
	query: {
		/** The tiles from user input (either from Finder or URL).
		 * Possibly alphabetised depending on requirement.
		 */
		tiles: "",
		/** The original tiles from user input (either from Finder or URL).
		 * Sanitized, but not alphabetized
		 */
		unsortedTiles: "",

		/** The tiles used to automatically find alternatives based on the original user input
		 */
		prefixedTiles: "",

		/**
		 * Integer value binded to FOURPICS word length select
		 */
		wordLength: null,

		/**
		 * String value for the advanced search option 'Starts With'
		 */
		startsWith: "",

		/**
		 * String value for the advanced search option 'Ends With'
		 */
		endsWith: "",

		/**
		 * String value for the advanced search option 'Contains'
		 */
		contains: "",

		/**
		 * String value that contains dictionary name or game name
		 */
		dictionary: null,

		/**
		 * Flags any focused advanced search field individually
		 */
		focusedAdvanceFields: {
			startsWith: false,
			contains: false,
			endsWith: false,
			wordLength: false,
		},
		/**
		 * String value describing the criteria by which we want to result entries to be ordered
		 */
		orderBy: "score",
	},

	/** Unscrambler-like query results */
	results: {
		/**
		 * Total results count from the API response. It accounts for all different words returned as flat items, groups and exact_match.
		 */
		resultsCount: 0,

		/**
		 * If user input is an actual word in `words`, match will contain this
		 * same word.
		 */
		match: "",

		/**
		 * List of possible similar wordlist pages with results.
		 */
		suggestedLinks: {},

		/**
		 * List of word list pages that can be linked
		 */
		interlinks: {},
	},
	/** The height of the search container in finder component */
	finderHeight: 0,
	lastVisited: null,
	/**
	 * The List of saved words, (Saved by clicking save word option from the result table)
	 */
	savedWords: [],
	/**
	 * The list of API-returned words, grouped per table.
	 */
	words: {},
	relatedLists: [],
	/**
	 * An object holding information about opened modals
	 */
	openedModals: {},
	/**
	 * Flag set to true when the loading of the saved words is in progress.
	 */
	loadingSavedWords: false,
	anagrams: {},

	/**
	 * Flag set to true when we want to hide all ads on an article. See WFW-5106 for more.
	 */
	hideArticleAds: false,
};
